import React from 'react';
import PropTypes from 'prop-types';
import PressContactInput from './PressContactInput';
import CheckboxInputField from './CheckboxInputField';

const PressContactsInputSection = ({
  submitterName,
  submitterEmail,
  contactInstances,
  getGroupFields,
  addContact,
  removeContact,
  setField,
  validateField,
}) => {
  // Get the first contact instance
  const firstInstanceId = contactInstances[0];
  const firstContactFields = getGroupFields('press_contacts', firstInstanceId);

  // Check if "Use same contact info" is currently active
  const isSameContactInfo = (
    firstContactFields.name.value === submitterName
    && firstContactFields.email.value === submitterEmail
  );

  const handleUseSameContactInfo = (event) => {
    if (event.target.checked) {
      setField({
        target: { name: firstContactFields.name.name, value: submitterName },
      });
      setField({
        target: {
          name: firstContactFields.email.name,
          value: submitterEmail,
        },
      });
    } else {
      setField({ target: { name: firstContactFields.name.name, value: '' } });
      setField({ target: { name: firstContactFields.email.name, value: '' } });
    }
  };

  const handleDelete = (instanceId) => {
    if (contactInstances.length > 1) {
      removeContact(instanceId);
    }
  };

  return (
    <>
      <CheckboxInputField
        className="press-contacts-checkbox"
        id="use_same_contact_info"
        label="Use same contact information"
        onChange={handleUseSameContactInfo}
        checked={isSameContactInfo}
      />

      {contactInstances.map((instanceId, index) => {
        const contactFields = getGroupFields('press_contacts', instanceId);
        const key = `press-contact-${instanceId}`;

        return (
          <PressContactInput
            index={index}
            key={key}
            nameField={contactFields.name}
            emailField={contactFields.email}
            phoneField={contactFields.phone_number}
            onFieldChange={setField}
            onFieldBlur={validateField}
            onDelete={() => handleDelete(instanceId)}
            canDelete={contactInstances.length > 1}
          />
        );
      })}

      {contactInstances.length < 5 && (
        <button className="press-contacts__add" id="contacts-add-button" type="button" onClick={addContact}>
          <img className="add-image" src="/static/images/plus.svg" alt="Plus icon" />
          Add additional contact person
        </button>
      )}
    </>
  );
};

PressContactsInputSection.propTypes = {
  // eslint-disable-next-line react/forbid-prop-types
  submitterName: PropTypes.string.isRequired,
  submitterEmail: PropTypes.string.isRequired,
  contactInstances: PropTypes.arrayOf(PropTypes.string).isRequired,
  getGroupFields: PropTypes.func.isRequired,
  addContact: PropTypes.func.isRequired,
  removeContact: PropTypes.func.isRequired,
  setField: PropTypes.func.isRequired,
  validateField: PropTypes.func.isRequired,
};

export default PressContactsInputSection;
